import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import About from '../Pages/About/About'
import FormSignup from "../Pages/Register/FormSignup";
import FormLogin from "../Pages/Login/FormLogin";
import LandingPage from "../Pages/LandingPage/LandingPage";
import NavbarChall from "../Components/Navbar/NavbarChall";
import Challenges from "../Pages/Challenges/Challenges"
import Scoreboard from "../Pages/Scoreboard/Scoreboard";
import AccountProfileDetails from "../Pages/UserProfile/AccountProfileDetails";
import Teams from '../Pages/Teams/Teams'
import Error from '../Pages/Error';
import Sidebar from '../Components/Navbar/Sidebar'
import ChallengesAdmin from '../Pages/Admin/Challenges/ChallengesAdmin'
import UserAdmin from '../Pages/Admin/Users/UserAdmin'
import TeamsAdmin from '../Pages/Admin/Teams/TeamsAdmin'
import Challenges2 from '../Pages/Challenges/Challenges2';
import ConfigAdmin from '../Pages/Admin/Config/ConfigAdmin';
import Home from '../Pages/Home/Home';
import Learn from '../Pages/Learn/Learn';
import Learn2 from '../Pages/Learn/Learn2';
import LearnAdmin from '../Pages/Admin/Learn/LearnAdmin';
import Learn3 from '../Pages/Learn/Learn3';
import Writeups from '../Pages/Writeups/Writeups';
import WriteupsAdmin from '../Pages/Admin/Writeups/WriteupAdmin';
import BackupAdmin from '../Pages/Admin/Backup/BackupAdmin';
export default function AppRouter() {
    
    return (
        <Router>
            <Switch>
                <Route exact path="/" component={LandingPage} />
                <Route exact path="/login" component={FormLogin} />
                <Route exact path="/registro" component={FormSignup} />
                <Route exact path="/nosotros" component={About} />
                <Route path="/user" component={userRoutes} />
                <Route path="/admin" component={adminRoutes} />                
                < Route path="*" component={Error} />
            </Switch>
        </Router>
    )

}
function adminRoutes() {
    return (
        <div>
            <NavbarChall />
            <Sidebar/>
            <Switch>            
                <Route exact path="/admin" component={ChallengesAdmin} />
                <Route  path="/admin/usuarios" component={UserAdmin} />
                <Route  path="/admin/equipos" component={TeamsAdmin} />
                <Route  path="/admin/configuracion" component={ConfigAdmin} />
                <Route  path="/admin/aprendizaje" component={LearnAdmin} />
                <Route  path="/admin/writeups" component={WriteupsAdmin} />
                <Route  path="/admin/respaldos" component={BackupAdmin} />
                <Route path="*" component={Error} />
            </Switch>
        </div>
    )
}
function userRoutes() {
    return (
        <div>
            <NavbarChall />
            <Switch>            
                <Route exact path="/user" component={Home} />
                <Route exact path="/user/retos" component={Challenges} />
                <Route path="/user/retos/:id_challs" component={Challenges2} />
                <Route path="/user/perfil" component={AccountProfileDetails} />
                <Route exact path="/user/equipos" component={Teams} />
                <Route exact path="/user/puntuaciones" component={Scoreboard} />
                <Route exact path="/user/aprendizaje" component={Learn} />
                <Route exact path="/user/aprendizaje/:learn_id" component={Learn2} />
                <Route exact path="/user/aprendizaje/:learn_id/:content_id" component={Learn3} />
                <Route exact path="/user/writeups" component={Writeups} />
                <Route path="*" component={Error} />
            </Switch>
        </div>
    )
}

